import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { VisitsAndScheduledTasksTableType } from 'components/VisitsAndScheduledTasks/visitsAndScheduledTasks';

export interface VisitsAndScheduledTasksPageState {
  currentVisitsAndScheduledTasksTable: VisitsAndScheduledTasksTableType;
}

export const initialState: VisitsAndScheduledTasksPageState = {
  currentVisitsAndScheduledTasksTable: VisitsAndScheduledTasksTableType.PeriodReports,
};

const visitsAndScheduledTasksPageSlice = createSlice({
  name: 'VisitsAndScheduledTasksTable',
  initialState,
  reducers: {
    setCurrentVisitsAndScheduledTasksPageSliceTable(state, action: PayloadAction<VisitsAndScheduledTasksTableType>) {
      state.currentVisitsAndScheduledTasksTable = action.payload;
    },
  },
});

export const { setCurrentVisitsAndScheduledTasksPageSliceTable } = visitsAndScheduledTasksPageSlice.actions;

export default visitsAndScheduledTasksPageSlice.reducer;
